import _ from 'lodash'
import React from 'react'
import { VictoryAxis, VictoryBar, VictoryChart, VictoryLabel, VictoryTheme } from 'victory-native'

import { IXBarChartProps } from 'x/types'
import p from 'x/config/platform-specific'

import { LayoutChangeEvent } from 'react-native'
import Box from './Box'
import VStack from './VStack'
import XText from './XText'

const customFontFamily = 'Prompt-Regular, sans-serif'
const customTheme = {
  ...VictoryTheme.material,
  axis: {
    ...VictoryTheme.material.axis,
    style: {
      ...VictoryTheme.material.axis.style,
      tickLabels: {
        fontFamily: customFontFamily,
        fontSize: 10,
        padding: 5,
      },
      axisLabel: {
        fontFamily: customFontFamily,
        fontSize: 12,
      },
    },
  },
  legend: {
    ...VictoryTheme.material.legend,
    style: {
      labels: {
        fontFamily: customFontFamily,
        fontSize: 10,
      },
    },
  },
  labels: {
    fontFamily: customFontFamily,
    fontSize: 10,
  },
}

type IState = {
  containerWidth: number
  chartWidth: number
}
export default class XBarChart extends React.Component<IXBarChartProps, IState> {
  static displayName = 'XBarChart'

  static defaultProps = {
    tickCountX: 7,
    tickCountY: 6,
    lineColor: 'blue',
  }

  constructor(props) {
    super(props)

    this.state = {
      containerWidth: 300,
      chartWidth: 292,
    }
  }

  getFontSize = () => {
    const { fontSize } = this.props

    if (fontSize && fontSize > 0) {
      return fontSize
    }

    const { containerWidth } = this.state

    if (containerWidth <= 200) {
      return 10
    }

    if (containerWidth <= 300) {
      return 12
    }

    if (containerWidth <= 400) {
      return 14
    }

    return 16
  }

  _getLimitTickFormatFunction = (dataCount = 0, parseFunction = null) => {
    const { tickCountX } = this.props
    if (dataCount >= tickCountX) {
      const splitedPoint = tickCountX
      return _.isFunction(parseFunction)
        ? (data, index) => (index % splitedPoint === 0 ? parseFunction(data) : null)
        : (data, index) => (index % splitedPoint === 0 ? data : null)
    }
    return _.isFunction(parseFunction) ? (data) => parseFunction(data) : (data) => data
  }

  getDataCount = () => {
    const { data } = this.props
    return data.length || 0
  }

  getTickValuesY = () => {
    const { data, tickCountY } = this.props
    const tickValues = []
    const max = Math.max(...data.map((d) => d.y)) || 1
    let stepValue = max / (tickCountY - 1)

    if (max >= 10) {
      stepValue = Math.round(stepValue)
    } else {
      return [0, 2, 4, 6, 8, 10]
    }

    stepValue = Math.round(stepValue * 100) / 100

    for (let i = 0; i < tickCountY - 1; i++) {
      tickValues.push(Math.round(i * stepValue * 100) / 100)
    }
    tickValues.push(max >= 10 ? Math.round(max) : max)
    return tickValues
  }

  renderBarChart = () => {
    const { chartWidth } = this.state
    const { data, tickFormatX, tickFormatY, tickCountY, tickCountX, lineColor } = this.props
    const dataCount = this.getDataCount()
    const tickLabelXFunc = this._getLimitTickFormatFunction(dataCount, tickFormatX)

    return (
      <VictoryChart
        // height={p.op.isWeb() ? 950 : 350}
        // width={p.op.isWeb() ? undefined : chartWidth}
        height={350}
        width={chartWidth}
        style={{
          // pointerEvents: 'none',
          background: { fill: '#f8f8f8' },
        }}
        domainPadding={{ x: 20, y: 10 }}
        padding={{
          top: 24,
          left: 48,
          right: 32,
          // bottom: 64, // ปรับพอประมาณให้ tick label ไม่โดนตัด
          bottom: Math.min(Math.max(50, chartWidth * 0.25), 100),
        }}
        theme={customTheme}
        // padding={{
        //   top: p.op.isWeb() ? 48 : 28,
        //   left: p.op.isWeb() ? Math.max(50, chartWidth * 0.2) : 50,
        //   bottom: p.op.isWeb() ? Math.max(100, chartWidth * 0.3) : 88,
        //   right: p.op.isWeb() ? Math.max(50, chartWidth * 0.1) : 50,
        // }}
      >
        <VictoryAxis
          style={{
            axis: { stroke: 28 },
            ticks: { stroke: 28 },
            tickLabels: {
              // fontSize: this.getFontSize(),
              fill: 'black',
              // fontFamily: 'Prompt',
              fontStyle: 'normal',
              // padding: 12,
            },
            grid: { stroke: '#B3E5FC', strokeWidth: 0.25 },
          }}
          dependentAxis
          tickFormat={tickFormatY}
          tickCount={this.getDataCount() > tickCountY ? tickCountY : this.getDataCount()}
          tickValues={this.getTickValuesY()}
        />
        <VictoryAxis
          style={{
            axis: {
              stroke: 28,
            },
            grid: {
              padding: 20,
            },
            tickLabels: {
              // fontSize: this.getFontSize(),
              fill: 'black',
              angle: 45,
              textAnchor: 'start',
              verticalAnchor: 'middle',
              // fontFamily: 'Prompt',
              fontStyle: 'normal',
              // padding: 2,
            },
          }}
          tickFormat={tickFormatX}
          tickCount={this.getDataCount() > tickCountX ? tickCountX : this.getDataCount()}
        />

        <VictoryBar
          name='Bar'
          style={{
            data: {
              width: this.getDataCount() < 7 ? Math.max(15, chartWidth / (dataCount * 2)) : undefined,
              fill: lineColor,
              fillOpacity: 0.8,
              strokeWidth: 1,
              strokeOpacity: 0.8,
              strokeLinecap: 'round',
              opacity: 1,
            },
            // labels: {
            //   fontSize: this.getFontSize(),
            // },
          }}
          data={data}
          animate={{
            duration: 1500,
            onLoad: { duration: 1000 },
            onExit: {
              duration: 500,
              before: () => ({
                _y1: 0,
                fill: 'orange',
              }),
            },
          }}
        />
      </VictoryChart>
    )
  }

  renderLabelX = () => {
    const { labelX } = this.props
    if (!labelX) {
      return null
    }
    return (
      <Box position='absolute' bottom='0' left='0' right='0' alignItems='center'>
        <XText>{labelX}</XText>
      </Box>
    )
  }

  renderLabelY = () => {
    const { labelY } = this.props
    if (!labelY) {
      return null
    }
    return (
      <Box position='absolute' left='0' top='40px'>
        <XText pl='40px'>{labelY}</XText>
      </Box>
    )
  }

  renderChartTitle = () => {
    const { title } = this.props
    if (!title) {
      return null
    }
    return (
      <Box minH='9' pt='2.5' position='absolute' top='0' left='0' right='0' justifyContent='center' alignItems='center'>
        <XText bold>{title}</XText>
      </Box>
    )
  }

  onContainerLayout = (evt: LayoutChangeEvent) => {
    try {
      const { width } = evt.nativeEvent.layout
      this.setState({ containerWidth: width, chartWidth: width - 8 })
    } catch (err) {
      console.log('onContainerLayout err =>', err)
    }
  }

  render() {
    return (
      <VStack w='full' p='1' pt='50px' pb='8px' onLayout={this.onContainerLayout}>
        {this.renderChartTitle()}
        {this.renderBarChart()}
        {this.renderLabelY()}
        {this.renderLabelX()}
      </VStack>
    )
  }
}
